import warning from "./warning/soft-warning.mp3";
import completion from "./completion/task-done.mp3";
import countdown from "./countdown/countdown-beep.mp3";
import transition from "./transition/double-tone-next.mp3";
import awareness from "./awareness/singing-bowl.mp3";

export const SOUND_CATEGORIES = [
  { id: "warning", label: "Manual task warning", description: "Countdown and overdue alerts." },
  { id: "completion", label: "Task completion", description: "When a task or the whole auto group finishes." },
  { id: "countdown", label: "Auto countdown", description: "At 5, 3 and 1 seconds before the next task." },
  { id: "transition", label: "Next task transition", description: "When auto mode moves to the next task." },
  { id: "awareness", label: "Awareness bell", description: "Your periodic reminder to refocus." },
];
export const DEFAULT_SOUNDS = Object.freeze({
  warning: "warning/soft-warning.mp3", completion: "completion/task-done.mp3",
  countdown: "countdown/countdown-beep.mp3", transition: "transition/double-tone-next.mp3",
  awareness: "awareness/singing-bowl.mp3",
});
const fallbackSources = { warning, completion, countdown, transition, awareness };
export function buildSoundCatalog(entries) {
  return SOUND_CATEGORIES.reduce((catalog, { id }) => {
    const options = entries.filter(([path]) => path.startsWith(`${id}/`)).map(([path, source]) => ({
      id: path, source,
      label: path.slice(id.length + 1).replace(/\.[^.]+$/, "").replace(/[/_-]+/g, " ").replace(/\b\w/g, (letter) => letter.toUpperCase()),
    })).sort((a, b) => a.label.localeCompare(b.label));
    if (!options.some((option) => option.id === DEFAULT_SOUNDS[id])) {
      options.unshift({ id: DEFAULT_SOUNDS[id], label: "Default", source: fallbackSources[id] });
    }
    catalog[id] = options;
    return catalog;
  }, {});
}
function discoverSounds() {
  // CRA's Jest runner does not implement webpack's asset discovery API.
  if (process.env.NODE_ENV === "test") return [];
  const files = require.context("./", true, /\.(mp3|wav|ogg|m4a|aac)$/i);
  return files.keys().map((path) => [path.replace(/^\.\//, ""), files(path).default || files(path)]);
}
export const soundCatalog = buildSoundCatalog(discoverSounds());
export const resolveSoundId = (category, selected) => soundCatalog[category].some((sound) => sound.id === selected)
  ? selected : DEFAULT_SOUNDS[category];
export const getSoundSource = (category, selected) => soundCatalog[category]
  .find((sound) => sound.id === resolveSoundId(category, selected)).source;
export const allSoundSources = [...new Set(Object.values(soundCatalog).flat().map((sound) => sound.source))];
